module.exports = __webpack_public_path__ + "static/media/carro-veloe.a30178ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/carro-veloe.png
// module id = 624
// module chunks = 0